import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

// -- actions
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- constants
import Events from 'constants/Events';

// -- stores
import RestaurantMenuStore from 'stores/RestaurantMenuStore';

// -- entities
import MenuPartCategory from 'PMT/entities/menu/MenuPartCategory';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';

import { Utils } from 'PMT/utils';

// -- views
import AbstractComponent from 'components/AbstractComponent';
import SubmitArea from 'PMT/components/form/SubmitArea';
import Form from './Form';

class View extends AbstractComponent {
  static propTypes = {
    category: PropTypes.objectOf(MenuPartCategory),
    parentCategory: PropTypes.objectOf(MenuPartCategory),

    isEditMode: PropTypes.bool.isRequired,

    restaurantMenu: PropTypes.objectOf(RestaurantMenu),
  };

  state = {
    category: this.props.category.copy(),

    imageData: null,
  };

  componentDidMount() {
    RestaurantMenuStore.addListener(
      Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_ERROR,
      this.onError
    );

    RestaurantMenuStore.addListener(
      Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
      this.onSuccess
    );
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(
      Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_ERROR,
      this.onError
    );

    RestaurantMenuStore.removeListener(
      Events.ON_UPDATE_RESTAURANT_MENU_MENU_PART_CATEGORY_SUCCESS,
      this.onSuccess
    );
  }

  get restaurantMenu(): RestaurantMenu {
    return this.props.restaurantMenu;
  }

  get category(): MenuPartCategory {
    return this.state.category;
  }

  get haveModifications(): boolean {
    return !this.state.category.equals(this.props.category);
  }

  // --

  onSuccess = () => {
    this.hideLoading();
    this.props.onHide();
  };

  onError = () => {
    // TODO: onError
    this.hideLoading();
    alert('An error occured');
  };

  // -- form
  onSubmit = () => {
    const restaurantMenu: RestaurantMenu = this.props.restaurantMenu;
    const menuPart = this.props.menuPart;
    const menu = this.props.menu;

    const parentCategory = this.props.parentCategory
    const menuPartCategory = this.state.category;

    if (this.props.isEditMode) {
      this.showLoading();
      RestaurantMenuAction.updateMenuPartCategory(
        menu,
        menuPart,
        menuPartCategory
        )
    } else {
      menuPartCategory.id = Utils.generateUID()

      parentCategory.addCategory(menuPartCategory)
      menuPart.updateCategory(parentCategory)

      // add to the menu part
      menuPart.addCategory(menuPartCategory)

      // update objects
      menu.updatePart(menuPart)
      restaurantMenu.updateMenu(menu)

      this.showLoading()
      RestaurantMenuAction.updateMenuPart(menu, menuPart)
    }
  }

  onReset = () => {
    this.setState({
      category: this.props.category.copy(),
    });
  };

  onChange = category => {
    this.setState({
      category: category.copy(),
    });
  };

  handleImageChange = imageData => {
    this.props.onUploadPartCategoryImage(this.props.category, imageData);
  };

  //
  //
  //

  renderSubmitArea() {
    return (
      <SubmitArea
        haveModifications={this.haveModifications}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
      />
    );
  }

  renderForm() {
    return (
      <Form
        category={this.state.category}
        isEditMode={this.props.isEditMode}
        onChange={this.onChange}
        image={{
          data: this.state.imageData,
          onChange: this.handleImageChange,
          onRemove: () => this.props.onRemovePartCategoryImage(this.props.category),
        }}
      />
    );
  }

  render() {
    return (
      <div className="">
        {this.renderForm()}

        {this.renderSubmitArea()}

        {this.renderLoading()}
      </div>
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./scripts/pages/menu/menuPartEdit/ModifyCategoryModal/View.js